import { getIssueCreateRoute } from '@core/helpers/methods/core-issue-create-route.helper';
import { Injectable } from "@angular/core";
import {ResourceProfileFeatureDto} from "@server-models";
import _ from "lodash";


@Injectable({
  providedIn: 'root'
})
export class LinkLoginService {
  getHomeRoute(features?: ResourceProfileFeatureDto, resourceId?: number): string {
    if (!features || !resourceId) return '/link/login';
    const base = `/link/${resourceId}/`;
    if (features.isDashboardVisible || features.isSubsystemEnabled) return base + 'home';
    if (features.isKnowledgeVisible) return base + this.getKnowledgeRoute(features);
    if (features.isShowingProperties) return base + 'properties';
    if (features.isIssueHistoryVisible || features.isIssueTemplateVisible) return base + this.getIssueRoute(features);
    return '/link/error';
  }

  getIssueRoute(features: ResourceProfileFeatureDto): string {
    if (features.isIssueHistoryVisible) return 'issues';
    return _.isNumber(features.issueTemplateShortcutId)
      ? getIssueCreateRoute(features.issueTemplateShortcutId, features.issueTemplateShortcut?.contentType)?.join('/') ?? 'issues/templates'
      : 'issues/templates';
  }

  getKnowledgeRoute(features: ResourceProfileFeatureDto): string {
    if (_.isNumber(features?.knowledgeShortcutId)) {
      return `knowledge/${ features.knowledgeShortcutId }`;
    } else {
      return 'knowledge'
    }
  }
}
